import Page from '../../common/page'

const state = Object.assign({}, Page.state, {
  sourceFilter: null // myFiles (null/default), 'shared', or 'organization'
})

state.endpoint = 'files/recent'
state.sortOptions = {
  'Date': ['-created_datetime'],
  'Name': ['name']
}

const getters = {
  ...Page.getters,
  sourceFilter: state => state.sourceFilter,
  hasActiveFilter: state => state.sourceFilter !== null && state.sourceFilter !== 'myFiles'
}

const mutations = {
  ...Page.mutations,
  setSourceFilter (state, value) {
    state.sourceFilter = value
  }
}

const actions = {
  ...Page.actions,
  setSourceFilter ({ commit }, value) {
    commit('setSourceFilter', value)
  },
  loadElements ({ commit, state, dispatch, rootGetters }, payload) {
    let params = payload || {}

    // Add access parameter based on filter
    if (state.sourceFilter === 'shared') {
      params.access = 'shared'
    } else if (state.sourceFilter === 'organization') {
      params.access = 'organization'
    }
    // null or 'myFiles' = no access param (default)

    return Page.actions.loadElements.call(this, { commit, state, dispatch, rootGetters }, params)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/files/recents/recents.js